import { defineStore } from 'pinia'

type Experiment = {
  variant: string | null
  enabled: boolean
}

/**
 * A/B experiment variants.
 */
export const useExperimentsStore = defineStore('experiments', {
  state: () => ({
    experiments: {} as Record<string, Experiment>,
  }),
  actions: {
    updateExperiment([experimentCode, experimentPartialData]: [string, Partial<Experiment>]) {
      this.experiments = {
        ...this.experiments,
        [experimentCode]: {
          ...(this.experiments[experimentCode] || {}),
          ...experimentPartialData,
        } as Experiment,
      }
    },
  },
})
